import { baseState, baseMutations } from '@/store/mixins'
import thesis from '@/api/thesis'
import thesisTopic from '@/api/thesis-topic'
import TeacherProfile from '@/api/teacher-profile'
import Year from '@/api/academic-year'
import SubProgram from '@/api/sub-program'
import level from '@/api/level'
import Term from '@/api/term-semester'
import ClassOperation from '@/api/class-operation'
import student from '@/api/student-profile'

export const state = {
  ...baseState,
  topics: [],
  class_options: [],
  editData: [],
  currentFolder: undefined,
  currentFolderId: undefined,
  direction: 'ASC',
  files: []
}

export const mutations = {
  ...baseMutations,
  SET_TOPICS (state, data) {
    state.topics = data
  },
  SET_EDIT_DATA (state, data) {
    state.editData = data
  },
  SET_FILES (state, file) {
    state.files = file
  },
  SET_COMMITTEE (state, data) {
    state.committees = data
  },
  REMOVE_FILE_BY_INDEX(state, index) {
    state.files.splice(index, 1)
  }
}

export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return thesis.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getTopic (context, attributes = {}) {
    return thesisTopic.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          thesis_topics: 'topic_id,topic_name_en,topic_name_kh'
        },
        ...attributes
      }
    })
  },
  getTeacher (context, attributes = {}) {
    return TeacherProfile.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          setup_teacher_profiles: 'teacher_id,fname_foreign,lname_foreign'
        },
        ...attributes
      }
    })
  },
  getYear (context, attributes = {}) {
    return Year.get({
      params: Object.assign(
        {
          fields: {
            academic_years: 'ac_year_id,ac_year,ac_status_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubProgram (context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLevel (context, attributes = {}) {
    return level.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_levels:
            'acps_id,level_id,level_name_foreign,level_name_native'
        },
        ...attributes
      }
    })
  },
  getTerm (context, attributes = {}) {
    return Term.get({
      params: Object.assign(
        {
          fields: {
            academic_terms: 'ac_term_id,term_name,ac_status_id,term_order'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getClass (context, attributes = {}) {
    return ClassOperation.get({
      params: Object.assign(
        {
          fields: {
            academic_classes: 'class_id,class_name'
          },
          filter: {
            required_thesis: true
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  async getStudent (context, attrubutes = {}) {
    let params = Object.assign(
      {
        include: 'sub_program,level',
        fields: {
          setup_student_profiles:
            'student_id,card_number,first_name_en,last_name_en,gender,phone,date_of_birth,acps_id,promotion,level_id',
          sub_program: 'acps_id,acps_name_foreign',
          level: 'level_id,level_name_foreign'
        }
      },
      attrubutes
    )
    return await student.get({ params })
  },

  store (context, data) {
    return thesis.store(data)
  },
  update (context, data) {
    return thesis.update(data)
  },
  delete (context, data) {
    return thesis.destroy(data)
  },
  committee (context, data) {
    return thesis.committee(data)
  },
  attachFile (context, data) {
    return thesis.attachFile(data)
  },
  async find (context, id) {
    if (_.isEmpty(context.state.editData)) {
      let response = await thesis.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getFile (context, thesis_reg_id, attrubutes = {}) {
    let params = Object.assign(
      {
        sort: 'updated_at',
        direction: context.state.direction
      },
      attrubutes
    )
    return thesis.getFile(thesis_reg_id, { params }).then(response => {
      let files = response.files.data
      context.commit('SET_FILES', files)
    })
  },
  deleteItem (context, id) {
    return thesis.deleteItem(id)
  },
  getCommittee (context, attrubutes = {}) {
    return thesis.fetchCommittee(attrubutes)
  }
}
